import { memo } from 'react';

import {
    RouletteRoadMapCellProps,
    useRouletteRoadMapCellColorText,
} from '../hook';
import { ROAD_MAP_TYPE } from '../../../lobby/constants';

const RedBlackRoadCell = (props: RouletteRoadMapCellProps) => {
    const {
        record: { Win },
        size,
    } = props;

    const { color, text } = useRouletteRoadMapCellColorText(
        ROAD_MAP_TYPE.RED_BLACK,
        Win
    );

    return (
        <svg width={size} height={size}>
            {Win >= 0 && (
                <>
                    <rect fill={color} width={size} height={size} />
                    <text
                        x={size / 2}
                        y={size / 2 + 1}
                        textAnchor="middle"
                        dominantBaseline="middle"
                        fill="#ffffff"
                        fontSize={size * 0.75}
                    >
                        {text}
                    </text>
                </>
            )}
        </svg>
    );
};

export default memo(RedBlackRoadCell);
